import React from "react";

const SpaceBetweenTables = ({ height = 50 }) => {
  return <div style={{ height: `${height}px` }}></div>;
};

export default SpaceBetweenTables;
